<template>
    <!-- 홈 캘린더 — 보호소 공유 일정(직접 등록, 완료 체크) + 자동 항목(입양신청·접종 예정·키트 재검사·공고 종료). 체크박스로 종류별 보기 -->
    <div class="hc">
        <h4 class="fs-20 hc-title">일정</h4>
        <div class="hc-head">
            <div class="hc-nav">
                <button type="button" class="hc-icon-btn" :title="'이전 ' + unitLabel" @click="move(-1)"><i class="bi bi-chevron-left"></i></button>
                <!-- 날짜를 누르면 연·월 고르기 -->
                <div class="hc-month-wrap">
                    <button type="button" class="hc-month" :class="{ open: !!picker }" title="월 선택" @click="togglePicker()">{{ rangeLabel }} <i class="bi bi-caret-down-fill"></i></button>
                    <template v-if="picker">
                        <div class="hc-picker-backdrop" @click="picker = null"></div>
                        <div class="hc-picker" @click.stop>
                            <div class="hc-picker-head">
                                <button type="button" class="hc-icon-btn" title="이전 해" @click="picker.year--"><i class="bi bi-chevron-left"></i></button>
                                <b>{{ picker.year }}년</b>
                                <button type="button" class="hc-icon-btn" title="다음 해" @click="picker.year++"><i class="bi bi-chevron-right"></i></button>
                            </div>
                            <div class="hc-picker-grid">
                                <button v-for="m in 12" :key="m" type="button" class="hc-picker-month"
                                        :class="{ on: picker.year == cursor.year() && m - 1 == cursor.month(), now: picker.year == nowYear && m - 1 == nowMonth }"
                                        @click="goMonth(picker.year, m - 1)">{{ m }}월</button>
                            </div>
                        </div>
                    </template>
                </div>
                <button type="button" class="hc-icon-btn" :title="'다음 ' + unitLabel" @click="move(1)"><i class="bi bi-chevron-right"></i></button>
            </div>
            <!-- 일 / 주 / 월 보기 -->
            <div class="hc-views ms-auto">
                <button v-for="v in VIEWS" :key="v.key" type="button" class="hc-view" :class="{ on: view == v.key }" @click="setView(v.key)">{{ v.label }}</button>
            </div>
            <button type="button" class="btn hc-add-btn" :disabled="!scheduleReady" :title="scheduleReady ? '' : '일정 테이블 준비 중입니다.'" @click="openForm(null, todayStr)"><i class="bi bi-plus-lg"></i> 일정 추가</button>
        </div>

        <!-- 필터: 위 = 자동 항목(접종 예정·키트 재검사), 아래 = 일정 구분별 칩 + 완료 숨기기 -->
        <div class="hc-filters">
            <div class="hc-frow">
                <div class="hc-fchips">
                    <button v-for="t in AUTO_TYPES" :key="t.key" type="button" class="hc-fchip" :class="{ on: filters[t.key], zero: !countByType[t.key] }"
                            :style="fchipVars(t.color)" :aria-pressed="!!filters[t.key]" @click="toggleFilter(t.key)">
                        <span class="hc-fchip-dot"></span>{{ t.label }}<span v-if="countByType[t.key]" class="hc-fchip-count">{{ countByType[t.key] }}</span>
                    </button>
                </div>
            </div>
            <div class="hc-frow">
                <div class="hc-fchips">
                    <button v-for="c in catList" :key="c.key" type="button" class="hc-fchip" :class="{ on: catOn(c.key), zero: !countByCat[c.key] }"
                            :style="fchipVars(c.color)" :aria-pressed="catOn(c.key)" @click="toggleCat(c.key)">
                        <span class="hc-fchip-dot"></span>{{ c.key }}<span v-if="countByCat[c.key]" class="hc-fchip-count">{{ countByCat[c.key] }}</span>
                    </button>
                </div>
                <label class="hc-filter hc-filter-done" style="--c: #9a9a9a">
                    <input type="checkbox" :checked="hideDone" @change="setHideDone(!hideDone)"/>
                    <span class="hc-check"><i class="bi bi-check"></i></span>
                    완료 숨기기
                </label>
                <span v-if="loading" class="hc-loading">불러오는 중…</span>
            </div>
        </div>

        <div v-if="view == 'month'" class="hc-grid">
            <div v-for="(w, i) in WEEKDAYS" :key="'w' + i" class="hc-weekday" :class="{ sun: i == 0, sat: i == 6 }">{{ w }}</div>
            <div v-for="d in days" :key="d.date" class="hc-day" :class="{ other: !d.inMonth, today: d.date == todayStr }" @click="onDayClick(d.date, $event)">
                <div class="hc-day-num" :class="{ sun: d.dow == 0, sat: d.dow == 6 }">
                    <span title="이 날 보기" @click.stop="isMobile ? openDay(d.date, $event) : goDay(d.date)">{{ d.day }}</span>
                </div>
                <div class="hc-events">
                    <button v-for="e in visibleOf(d.date).slice(0, MAX_PER_DAY)" :key="e.type + e.id + d.date" type="button"
                            class="hc-chip" :class="chipClass(e)" :style="colorVars(e)" :title="chipTitle(e)"
                            @click.stop="openDetail(e, $event)">
                        <span v-if="e.time" class="hc-dot"></span>
                        <span v-if="e.time" class="hc-time">{{ e.time }}</span>
                        <span class="hc-chip-text">{{ chipText(e) }}</span>
                    </button>
                    <button v-if="visibleOf(d.date).length > MAX_PER_DAY" type="button" class="hc-more" :data-more="'+' + (visibleOf(d.date).length - MAX_PER_DAY)" @click.stop="openDay(d.date, $event)">
                        +{{ visibleOf(d.date).length - MAX_PER_DAY }}개 더보기
                    </button>
                </div>
            </div>
        </div>
        <!-- 주 / 일: 위 종일 줄 + 시간표 (구글 캘린더처럼 시간 칸을 누르면 그 시간으로 일정 추가) -->
        <div v-else class="hc-tg" :class="'v-' + view">
            <div class="hc-tg-row hc-tg-head">
                <div class="hc-tg-gutter"></div>
                <div v-for="d in colDays" :key="'h' + d.date" class="hc-tg-col-head" :class="{ today: d.date == todayStr, sun: d.dow == 0, sat: d.dow == 6 }">
                    <span class="hc-tg-dow">{{ WEEKDAYS[d.dow] }}</span>
                    <span class="hc-tg-date" :title="view == 'week' ? '이 날 보기' : ''" @click="view == 'week' && goDay(d.date)">{{ d.day }}</span>
                </div>
            </div>
            <div class="hc-tg-row hc-tg-allday">
                <div class="hc-tg-gutter hc-tg-allday-label">종일</div>
                <div v-for="d in colDays" :key="'a' + d.date" class="hc-tg-allday-col" :class="{ today: d.date == todayStr }" @click="openForm(null, d.date)">
                    <button v-for="e in allDayOf(d.date).slice(0, allDayMax)" :key="e.type + e.id" type="button"
                            class="hc-chip" :class="chipClass(e)" :style="colorVars(e)" :title="chipTitle(e)" @click.stop="openDetail(e, $event)">
                        <span class="hc-chip-text">{{ chipText(e) }}</span>
                    </button>
                    <button v-if="allDayOf(d.date).length > allDayMax" type="button" class="hc-more" @click.stop="openDay(d.date, $event)">+{{ allDayOf(d.date).length - allDayMax }}개 더보기</button>
                </div>
            </div>
            <div class="hc-tg-body" ref="tgBody">
                <div class="hc-tg-row">
                    <div class="hc-tg-gutter">
                        <div v-for="h in 24" :key="'g' + h" class="hc-tg-hour-label" :style="{ height: HOUR_PX + 'px' }"><span v-if="h > 1">{{ hourLabel(h - 1) }}</span></div>
                    </div>
                    <div v-for="d in colDays" :key="'c' + d.date" class="hc-tg-col" :class="{ today: d.date == todayStr }" :style="{ height: HOUR_PX * 24 + 'px' }" @click="onSlotClick(d.date, $event)">
                        <div v-for="h in 24" :key="'l' + h" class="hc-tg-line" :style="{ top: (h - 1) * HOUR_PX + 'px' }"></div>
                        <div v-if="d.date == todayStr" class="hc-tg-now" :style="{ top: nowTop + 'px' }"></div>
                        <button v-for="b in timedOf(d.date)" :key="b.e.type + b.e.id" type="button" class="hc-tg-event" :class="{ done: b.e.done == 'Y', short: b.height < 34 }"
                                :style="Object.assign({ top: b.top + 'px', height: b.height + 'px', left: b.left + '%', width: b.width + '%' }, colorVars(b.e))"
                                :title="chipTitle(b.e)" @click.stop="openDetail(b.e, $event)">
                            <span class="hc-tg-event-title">{{ chipText(b.e) }}</span>
                            <span class="hc-tg-event-time">{{ b.e.time }}{{ b.e.end_time ? ' ~ ' + b.e.end_time : '' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <p v-if="!scheduleReady" class="hc-note">일정 직접 등록은 준비 중입니다. 자동 항목(입양신청·접종 예정·키트 재검사·공고 종료)만 표시됩니다.</p>

        <!-- 일정 상세 / 하루 전체 목록 (구글 캘린더처럼 클릭한 자리 옆에) -->
        <div v-if="pop" class="hc-backdrop" @click="pop = null"></div>
        <div v-if="pop" class="hc-pop" :style="pop.pos" @click.stop>
            <template v-if="pop.kind == 'day'">
                <div class="hc-pop-head">
                    <b>{{ dayLabel(pop.date) }}</b>
                    <!-- 모바일: 날짜를 누르면 이 목록이 먼저 → 여기서 일정 추가 -->
                    <button v-if="isMobile && scheduleReady" type="button" class="btn btn-sm btn-orange ms-auto hc-pop-add" @click="openForm(null, pop.date)"><i class="bi bi-plus-lg"></i> 일정 추가</button>
                    <button type="button" class="btn-close hc-close" :class="{ 'ms-auto': !(isMobile && scheduleReady) }" @click="pop = null"></button>
                </div>
                <p v-if="visibleOf(pop.date).length == 0" class="hc-pop-empty">일정이 없어요</p>
                <div class="hc-pop-list">
                    <button v-for="e in visibleOf(pop.date)" :key="e.type + e.id" type="button" class="hc-chip hc-chip-wide" :class="chipClass(e)" :style="colorVars(e)" @click="openDetail(e, $event, true)">
                        <span v-if="e.time" class="hc-dot"></span>
                        <span v-if="e.time" class="hc-time">{{ e.time }}</span>
                        <span class="hc-chip-text">{{ chipText(e) }}</span>
                    </button>
                </div>
            </template>
            <template v-else>
                <div class="hc-pop-head">
                    <span class="hc-pop-type" :style="colorVars(pop.e)">{{ typeLabel(pop.e) }}</span>
                    <div class="ms-auto hstack gap-1">
                        <template v-if="pop.e.type == 'schedule'">
                            <button type="button" class="hc-icon-btn" title="수정" @click="openForm(pop.e)"><i class="bi bi-pencil"></i></button>
                            <button type="button" class="hc-icon-btn" title="삭제" @click="remove(pop.e)"><i class="bi bi-trash"></i></button>
                        </template>
                        <button type="button" class="btn-close hc-close" @click="pop = null"></button>
                    </div>
                </div>
                <p class="hc-pop-title" :class="{ done: pop.e.done == 'Y' }">{{ detailTitle(pop.e) }}</p>
                <p class="hc-pop-when">{{ whenText(pop.e) }}</p>
                <!-- 같은 날 같은 동물 입양신청 묶음: 신청서마다 한 줄 -->
                <div v-if="pop.e.group" class="hc-pop-group">
                    <p class="hc-pop-group-animal"><i class="bi bi-tag"></i> {{ pop.e.animal_name ? pop.e.animal_name + ' · ' : '' }}{{ pop.e.notify_number }}</p>
                    <div v-for="r in pop.e.items" :key="r.id" class="hc-pop-req">
                        <span class="hc-time">{{ r.time }}</span>
                        <span class="hc-pop-req-name">{{ r.title || '-' }}</span>
                        <span class="hc-pop-req-state">{{ r.category }}</span>
                        <button type="button" class="btn btn-sm btn-outline-orange hc-pop-req-btn" @click="goRequest(r)">신청서</button>
                    </div>
                    <div class="hc-pop-actions">
                        <button type="button" class="btn btn-sm btn-outline-orange ms-auto" @click="goAnimal(pop.e)">동물 보기</button>
                    </div>
                </div>
                <template v-else>
                <div class="hc-pop-rows">
                    <p v-if="pop.e.notify_number"><i class="bi bi-tag"></i> {{ pop.e.animal_name ? pop.e.animal_name + ' · ' : '' }}{{ pop.e.notify_number }}</p>
                    <p v-if="pop.e.type == 'adopt'"><i class="bi bi-file-earmark-text"></i> 신청서 상태: <b>{{ pop.e.category }}</b></p>
                    <p v-if="pop.e.type == 'schedule' && pop.e.request_idx"><i class="bi bi-file-earmark-text"></i> 입양신청서{{ pop.e.applicant ? ' · ' + pop.e.applicant : '' }}{{ pop.e.request_state ? ' (' + pop.e.request_state + ')' : '' }}</p>
                    <p v-if="pop.e.type == 'kit' && pop.e.category"><i class="bi bi-eyedropper"></i> 이전 결과: <b>{{ pop.e.category }}</b></p>
                    <p v-if="pop.e.type == 'vaccine' || pop.e.type == 'kit'"><i class="bi" :class="pop.e.done == 'Y' ? 'bi-check-circle' : 'bi-hourglass-split'"></i> {{ pop.e.done == 'Y' ? (pop.e.type == 'kit' ? '재검사함' : '접종함') : '아직 기록 없음' }}</p>
                    <p v-if="pop.e.manager"><i class="bi bi-person"></i> {{ pop.e.manager }}</p>
                    <p v-if="pop.e.memo" class="hc-pop-memo"><i class="bi bi-text-left"></i> {{ pop.e.memo }}</p>
                </div>
                <div class="hc-pop-actions">
                    <label v-if="pop.e.type == 'schedule'" class="hc-done-toggle">
                        <input type="checkbox" class="form-check-input mt-0" :checked="pop.e.done == 'Y'" @change="toggleDone(pop.e, $event.target.checked)"/> 완료
                    </label>
                    <button v-if="pop.e.request_idx" type="button" class="btn btn-sm btn-orange ms-auto" @click="goRequest(pop.e)">신청서 보기</button>
                    <button v-if="pop.e.notify_number && pop.e.type != 'adopt'" type="button" class="btn btn-sm btn-outline-orange" :class="pop.e.request_idx ? '' : 'ms-auto'" @click="goAnimal(pop.e)">동물 보기</button>
                </div>
                </template>
            </template>
        </div>

    </div>
</template>

<script>
import { SCHEDULE_TYPES, SCHEDULE_CATEGORIES, scheduleColor, scheduleWhen, toggleScheduleDone, removeSchedule } from '@/utils/scheduleStore';
const moment = require('moment');

const FILTER_KEY = 'homeCalendarFilters';
const VIEW_KEY = 'homeCalendarView';
const VIEWS = [{ key: 'day', label: '일' }, { key: 'week', label: '주' }, { key: 'month', label: '월' }];
const HOUR_PX = 44;   //주·일 보기 1시간 높이
const HIDE_DONE_KEY = 'homeCalendarHideDone';
const CAT_FILTER_KEY = 'homeCalendarCatFilters';   //직접 일정 구분별 { 입양: false, ... } (없는 키 = 켜짐)
const catKeyOf = (e) => e.category || '기타';
//hex 두 색 섞기 (t = b 비율)
function mixHex(a, b, t) {
    const p = (h) => [1, 3, 5].map(i => parseInt(h.slice(i, i + 2), 16));
    const x = p(a), y = p(b);
    return '#' + x.map((v, i) => Math.round(v + (y[i] - v) * t).toString(16).padStart(2, '0')).join('');
}

function loadJson(key, def) {
    try { const v = JSON.parse(localStorage.getItem(key)); return v == null ? def : v; } catch (e) { return def; }
}

export default {
    name: 'HomeCalendar',
    props: { shelter: { type: Object, default: () => ({}) } },
    data() {
        const saved = loadJson(FILTER_KEY, {});
        const filters = {};
        SCHEDULE_TYPES.forEach(t => { filters[t.key] = saved[t.key] !== false; });
        //예전 '일정' 체크를 꺼둔 경우 → 구분 전부 꺼진 상태로 시작
        let catFilters = loadJson(CAT_FILTER_KEY, null);
        if (!catFilters || typeof catFilters != 'object') {
            catFilters = {};
            if (saved.schedule === false) SCHEDULE_CATEGORIES.forEach(c => { catFilters[c.key] = false; });
        }
        filters.schedule = true;   //직접 일정은 구분별(catFilters)로만 거름
        return {
            AUTO_TYPES: SCHEDULE_TYPES.filter(t => t.key != 'schedule' && t.key != 'notice_end'),   //공고 종료는 캘린더에서 뺌 (동물 상세 일정 카드엔 표시)
            catFilters,
            WEEKDAYS: ['일', '월', '화', '수', '목', '금', '토'], MAX_PER_DAY: 3, VIEWS, HOUR_PX,
            view: ['day', 'week', 'month'].includes(loadJson(VIEW_KEY, 'month')) ? loadJson(VIEW_KEY, 'month') : 'month',
            cursor: moment().startOf('day'),   //보고 있는 날 (월·주 보기는 이 날이 든 달·주)
            nowTop: 0,
            events: [],
            loading: false,
            scheduleReady: true,
            filters,
            hideDone: loadJson(HIDE_DONE_KEY, false) === true,
            pop: null,
            picker: null,   //월 선택 { year }
            nowYear: moment().year(), nowMonth: moment().month(),
            reqSeq: 0,
            isMobile: false,   //768px 이하 (모바일 화면): 월 보기 칸 간단히, 날짜 누르면 그날 목록, 상세는 아래에서 올라오는 시트
        };
    },
    computed: {
        todayStr() { return moment().format('YYYY-MM-DD'); },
        month() { return this.cursor.clone().startOf('month'); },
        unitLabel() { return this.view == 'day' ? '날' : (this.view == 'week' ? '주' : '달'); },
        rangeLabel() {
            //모바일은 칸이 좁아 주·일 보기에서 연도 생략
            const y = this.isMobile ? '' : 'YYYY년 ';
            if (this.view == 'month') return this.month.format('YYYY년 M월');
            if (this.view == 'day') return this.cursor.format(y + 'M월 D일') + ' (' + this.WEEKDAYS[this.cursor.day()] + ')';
            const a = this.cursor.clone().startOf('week'), b = a.clone().add(6, 'day');
            return a.month() == b.month() ? a.format(y + 'M월 D일') + ' ~ ' + b.format('D일') : a.format(y + 'M월 D일') + ' ~ ' + b.format('M월 D일');
        },
        gridStart() { return this.month.clone().startOf('week'); },
        //주·일 보기 열
        colDays() {
            const start = this.view == 'week' ? this.cursor.clone().startOf('week') : this.cursor.clone();
            const n = this.view == 'week' ? 7 : 1;
            const list = [];
            for (let i = 0; i < n; i++) {
                const d = start.clone().add(i, 'day');
                list.push({ date: d.format('YYYY-MM-DD'), day: d.date(), dow: d.day() });
            }
            return list;
        },
        //지금 보이는 기간 (조회·필터 건수)
        range() {
            if (this.view == 'month') return { start: this.days[0].date, end: this.days[this.days.length - 1].date };
            return { start: this.colDays[0].date, end: this.colDays[this.colDays.length - 1].date };
        },
        allDayMax() { return this.view == 'day' ? 8 : 3; },
        days() {
            const list = [];
            const d = this.gridStart.clone();
            for (let i = 0; i < 42; i++) {
                list.push({ date: d.format('YYYY-MM-DD'), day: d.date(), dow: d.day(), inMonth: d.month() == this.month.month() });
                d.add(1, 'day');
            }
            return list;
        },
        //날짜 → 그날 보이는 일정 (여러 날 일정은 걸친 날마다). 종일 먼저, 그다음 시간순
        byDate() {
            const map = {};
            const first = this.range.start, last = this.range.end;
            this.events.forEach(e => {
                if (!this.filters[e.type]) return;
                if (e.type == 'schedule' && !this.catOn(catKeyOf(e))) return;
                if (e.type == 'notice_end' || e.type == 'adopt') return;   //공고 종료·입양신청은 캘린더에 안 보임 (예전 서버가 보내도)
                if (this.hideDone && e.done == 'Y') return;
                let d = moment(e.date, 'YYYY-MM-DD');
                const end = e.end_date && e.end_date > e.date ? e.end_date : e.date;
                while (d.format('YYYY-MM-DD') <= end) {
                    const k = d.format('YYYY-MM-DD');
                    if (k >= first && k <= last) (map[k] = map[k] || []).push(e);
                    d.add(1, 'day');
                }
            });
            //입양신청: 같은 날 같은 동물은 '콩이 입양신청 n건' 한 칸으로 (1건도 같은 모양, 누르면 신청서 목록)
            Object.keys(map).forEach(k => {
                const byAnimal = {};
                map[k].forEach(e => { if (e.type == 'adopt') (byAnimal[e.notify_number] = byAnimal[e.notify_number] || []).push(e); });
                Object.values(byAnimal).forEach(list => {
                    const first = list[0];
                    const group = { type: 'adopt', group: true, id: 'g' + first.notify_number + k, date: k, time: null, notify_number: first.notify_number, animal_name: first.animal_name,
                        items: list.slice().sort((a, b) => (a.time || '').localeCompare(b.time || '')) };
                    map[k] = map[k].filter(e => !list.includes(e));
                    map[k].push(group);
                });
            });
            const typeOrder = SCHEDULE_TYPES.map(t => t.key);
            Object.values(map).forEach(l => l.sort((a, b) =>
                (a.time ? 1 : 0) - (b.time ? 1 : 0) || (a.time || '').localeCompare(b.time || '') || typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type)));
            return map;
        },
        //보이는 기간(월 보기는 그 달) 종류별 건수 — 필터 옆 숫자
        countByType() { return this.counts.type; },
        countByCat() { return this.counts.cat; },
        counts() {
            const type = {}, cat = {};
            const start = this.view == 'month' ? this.month.format('YYYY-MM-DD') : this.range.start;
            const end = this.view == 'month' ? this.month.clone().endOf('month').format('YYYY-MM-DD') : this.range.end;
            this.events.forEach(e => {
                if (this.hideDone && e.done == 'Y') return;
                if (!(e.date <= end && (e.end_date || e.date) >= start)) return;
                type[e.type] = (type[e.type] || 0) + 1;
                if (e.type == 'schedule') cat[catKeyOf(e)] = (cat[catKeyOf(e)] || 0) + 1;
            });
            return { type, cat };
        },
        //직접 일정 구분 칩: 입력창 구분(고정 순서) + 예전 구분·모르는 구분은 일정이 있을 때만 뒤에
        catList() {
            const list = SCHEDULE_CATEGORIES.filter(c => !c.legacy).map(c => ({ key: c.key, color: c.color }));
            const seen = new Set(list.map(c => c.key));
            this.events.forEach(e => {
                if (e.type != 'schedule') return;
                const k = catKeyOf(e);
                if (seen.has(k)) return;
                seen.add(k);
                list.push({ key: k, color: scheduleColor(e) });
            });
            return list;
        },
    },
    watch: {
        'shelter.shelter_device_number'() { this.load(); },
    },
    methods: {
        load() {
            const shelter = this.shelter && this.shelter.shelter_device_number;
            if (!shelter) return;
            const seq = ++this.reqSeq;
            const { start, end } = this.range;
            this.loading = true;
            this.axios.get(`/shelter/schedule?start=${start}&end=${end}&shelter_device_number=${encodeURIComponent(shelter)}`)
                .then(res => {
                    if (seq != this.reqSeq) return;
                    this.events = (res.data && res.data.events) || [];
                    this.scheduleReady = !(res.data && res.data.schedule_ready === false);
                })
                .catch(e => { console.log('캘린더 조회 실패', e); })
                .finally(() => { if (seq == this.reqSeq) this.loading = false; });
        },
        move(n) {
            this.pop = null; this.picker = null;
            this.cursor = this.cursor.clone().add(n, this.view == 'day' ? 'day' : (this.view == 'week' ? 'week' : 'month'));
            if (this.view == 'month') this.cursor = this.cursor.startOf('month');
            this.load();
        },
        togglePicker() {
            this.pop = null;
            this.picker = this.picker ? null : { year: this.cursor.year() };
        },
        //월 선택: 월 보기는 그 달, 주·일 보기는 이번 달이면 오늘 / 아니면 그 달 1일
        goMonth(y, m) {
            this.picker = null;
            const target = moment({ year: y, month: m, day: 1 });
            this.cursor = this.view != 'month' && target.isSame(moment(), 'month') ? moment().startOf('day') : target;
            this.load();
            this.scrollToMorning();
        },
        setView(v) {
            if (this.view == v) return;
            this.pop = null;
            //월 → 주·일: 이번 달이면 오늘, 아니면 그 달 1일 기준
            if (this.view == 'month' && v != 'month' && !this.cursor.isSame(moment(), 'month')) this.cursor = this.cursor.clone().startOf('month');
            else if (this.view == 'month' && v != 'month') this.cursor = moment().startOf('day');
            this.view = v;
            try { localStorage.setItem(VIEW_KEY, JSON.stringify(v)); } catch (e) { /* 이번 화면에서만 */ }
            this.load();
            this.scrollToMorning();
        },
        goDay(date) {
            this.pop = null;
            this.cursor = moment(date, 'YYYY-MM-DD');
            this.view = 'day';
            try { localStorage.setItem(VIEW_KEY, JSON.stringify('day')); } catch (e) { /* 이번 화면에서만 */ }
            this.load();
            this.scrollToMorning();
        },
        //주·일 보기: 처음엔 오전 8시부터 보이게
        scrollToMorning() {
            this.$nextTick(() => { if (this.$refs.tgBody) this.$refs.tgBody.scrollTop = HOUR_PX * 8 - 8; });
        },
        hourLabel(h) { return this.isMobile ? h + '시' : (h < 12 ? '오전 ' : '오후 ') + (h % 12 == 0 ? 12 : h % 12) + '시'; },
        //종일 줄: 시간 없는 일정·자동 항목, 여러 날 일정
        allDayOf(date) { return this.visibleOf(date).filter(e => !e.time || (e.end_date && e.end_date != e.date)); },
        //시간표: 시작·끝 시간으로 위치, 겹치면 나란히 (구글 캘린더처럼)
        timedOf(date) {
            const toMin = (t) => { const [h, m] = (t || '0:0').split(':').map(Number); return h * 60 + m; };
            const items = this.visibleOf(date).filter(e => e.time && !(e.end_date && e.end_date != e.date)).map(e => {
                const s = toMin(e.time);
                let en = e.end_time ? toMin(e.end_time) : s + 60;
                if (en <= s) en = s + 30;
                return { e, s, en };
            }).sort((a, b) => a.s - b.s || b.en - a.en);
            //겹치는 묶음마다 칸(lane) 나누기
            const out = [];
            let group = [], groupEnd = -1;
            const flush = () => {
                const lanes = [];
                group.forEach(it => {
                    let lane = lanes.findIndex(end => end <= it.s);
                    if (lane < 0) { lane = lanes.length; lanes.push(it.en); } else lanes[lane] = it.en;
                    it.lane = lane;
                });
                group.forEach(it => out.push({ e: it.e, top: it.s * HOUR_PX / 60, height: Math.max(20, (it.en - it.s) * HOUR_PX / 60 - 2), left: it.lane * 100 / lanes.length, width: 100 / lanes.length - 1 }));
                group = []; groupEnd = -1;
            };
            items.forEach(it => {
                if (group.length && it.s >= groupEnd) flush();
                group.push(it);
                groupEnd = Math.max(groupEnd, it.en);
            });
            if (group.length) flush();
            return out;
        },
        //빈 시간 칸 클릭 → 그 시간(30분 단위)으로 일정 추가
        onSlotClick(date, ev) {
            const rect = ev.currentTarget.getBoundingClientRect();
            const min = Math.max(0, Math.min(23 * 60 + 30, Math.floor((ev.clientY - rect.top) / HOUR_PX * 2) * 30));
            const t = String(Math.floor(min / 60)).padStart(2, '0') + ':' + String(min % 60).padStart(2, '0');
            this.openForm(null, date, t);
        },
        updateNow() {
            const n = moment();
            this.nowTop = (n.hours() * 60 + n.minutes()) * HOUR_PX / 60;
        },
        toggleFilter(key) {
            this.filters = { ...this.filters, [key]: !this.filters[key] };
            try { localStorage.setItem(FILTER_KEY, JSON.stringify(this.filters)); } catch (e) { /* 이번 화면에서만 */ }
        },
        catOn(key) { return this.catFilters[key] !== false; },
        saveCats() { try { localStorage.setItem(CAT_FILTER_KEY, JSON.stringify(this.catFilters)); } catch (e) { /* 이번 화면에서만 */ } },
        toggleCat(key) {
            this.catFilters = { ...this.catFilters, [key]: !this.catOn(key) };
            this.saveCats();
        },
        setHideDone(v) {
            this.hideDone = v;
            try { localStorage.setItem(HIDE_DONE_KEY, JSON.stringify(v)); } catch (e) { /* 이번 화면에서만 */ }
        },
        visibleOf(date) { return this.byDate[date] || []; },
        //필터 칩 색: 투명도 대신 흰색과 섞은 단색 (회색 바탕에서 탁해지지 않게) — 배경 연하게, 테두리 중간, 글자는 진하게
        fchipVars(c) { return { '--c': c, '--bg': mixHex(c, '#ffffff', .84), '--bd': mixHex(c, '#ffffff', .55), '--ink': mixHex(c, '#000000', .3) }; },
        colorOf(e) { return scheduleColor(e); },
        colorVars(e) {
            const c = this.colorOf(e);
            return { '--c': c, '--bg': c + '29', '--bg2': c + '47' };
        },
        typeLabel(e) {
            if (e.type == 'schedule') return '일정 · ' + (e.category || '기타');
            const t = SCHEDULE_TYPES.find(x => x.key == e.type);
            return t ? t.label : e.type;
        },
        chipClass(e) {
            return { timed: !!e.time, done: e.done == 'Y', multi: !!e.end_date };
        },
        //칸이 좁아서 짧게: 입양신청 = 동물 이름(없으면 공고번호 뒤쪽) + 신청자, 접종·재검사 = 동물 + 항목
        chipText(e) {
            const animal = e.animal_name || (e.notify_number ? e.notify_number.split('-').slice(-1)[0] : '');
            if (e.type == 'adopt' && e.group) return (animal ? animal + ' ' : '') + '입양신청 ' + e.items.length + '건';
            if (e.type == 'adopt') return (animal ? animal + ' ' : '') + '입양신청' + (e.title ? ' · ' + e.title : '');
            if (e.type == 'vaccine' || e.type == 'kit') return (animal ? animal + ' ' : '') + (e.title || '');
            //공고 종료: 서버 문구(예전 '공고 마감')와 상관없이 화면에서 만듦
            if (e.type == 'notice_end') return (e.animal_name || e.notify_number || '') + ' 공고 종료';
            return e.title || '';
        },
        chipTitle(e) { return this.detailTitle(e) + (e.time ? ' (' + e.time + ')' : ''); },
        detailTitle(e) {
            if (e.type == 'adopt' && e.group) return (e.animal_name || e.notify_number) + ' 입양신청 ' + e.items.length + '건';
            if (e.type == 'notice_end') return (e.animal_name || e.notify_number || '') + ' 공고 종료';
            if (e.type == 'adopt') return '입양신청' + (e.title ? ' — ' + e.title : '');
            return e.title || '';
        },
        //요일은 직접 (moment.locale 은 전역이라 다른 화면 날짜 표기에 영향)
        dayLabel(date) { const m = moment(date, 'YYYY-MM-DD'); return m.format('M월 D일') + ' (' + this.WEEKDAYS[m.day()] + ')'; },
        whenText(e) { return scheduleWhen(e, moment); },
        //클릭한 자리 옆에 띄움 (화면 밖으로 안 나가게)
        popPos(ev, width, height) {
            const r = ev.currentTarget.getBoundingClientRect();
            let left = r.right + 8;
            if (left + width > window.innerWidth - 8) left = Math.max(8, r.left - width - 8);
            let top = Math.min(r.top, window.innerHeight - height - 8);
            return { left: left + 'px', top: Math.max(8, top) + 'px', width: width + 'px' };
        },
        openDetail(e, ev, keepPos) {
            const pos = keepPos && this.pop ? this.pop.pos : this.popPos(ev, 320, 260);
            this.pop = { kind: 'event', e, pos };
        },
        openDay(date, ev) {
            this.pop = { kind: 'day', date, pos: this.popPos(ev, 280, 320) };
        },
        //월 보기 날짜 칸: PC 는 바로 일정 추가, 모바일은 칸이 좁아 그날 목록부터
        onDayClick(date, ev) {
            if (this.isMobile) this.openDay(date, ev);
            else this.openForm(null, date);
        },
        onMediaChange() { this.isMobile = !!(this.mq && this.mq.matches); },
        goRequest(e) {
            this.pop = null;
            this.$router.push({ path: '/adoption', query: { request: e.request_idx } });
        },
        goAnimal(e) {
            this.pop = null;
            this.$router.push({ path: '/animal', query: { notify: e.notify_number } });
        },
        // ── 직접 등록 일정 (입력창은 공통 ScheduleFormModal) ──
        openForm(e, date, time) {
            if (!e && !this.scheduleReady) return;
            this.pop = null;
            this.emitter.emit('openScheduleForm', { shelter_device_number: this.shelter.shelter_device_number, event: e || null, preset: e ? null : { date, time: time || null } });
        },
        toggleDone(e, on) { toggleScheduleDone(this, e, on); },
        remove(e) { removeSchedule(this, e).then(ok => { if (ok) this.pop = null; }); },
        onScheduleChanged() { this.load(); },
        //홈 요약 '오늘 일정' → 오늘 일 보기 + 달력으로 스크롤
        onGoDay(p) {
            this.goDay((p && p.date) || this.todayStr);
            this.$nextTick(() => { if (this.$el && this.$el.scrollIntoView) this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },
        onKey(ev) {
            if (ev.key == 'Escape' && this.pop) this.pop = null;
            if (ev.key == 'Escape' && this.picker) this.picker = null;
        },
    },
    mounted() {
        this.mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
        this.onMediaChange();
        if (this.mq) (this.mq.addEventListener ? this.mq.addEventListener('change', this.onMediaChange) : this.mq.addListener(this.onMediaChange));
        this.load();
        window.addEventListener('keyup', this.onKey);
        this.emitter.on('scheduleChanged', this.onScheduleChanged);
        this.emitter.on('homeCalendarGoDay', this.onGoDay);
        this.updateNow();
        this.nowTimer = setInterval(this.updateNow, 60000);
        this.scrollToMorning();
    },
    beforeUnmount() {
        if (this.mq) (this.mq.removeEventListener ? this.mq.removeEventListener('change', this.onMediaChange) : this.mq.removeListener(this.onMediaChange));
        window.removeEventListener('keyup', this.onKey);
        this.emitter.off('scheduleChanged', this.onScheduleChanged);
        this.emitter.off('homeCalendarGoDay', this.onGoDay);
        clearInterval(this.nowTimer);
    },
};
</script>

<style scoped>
    /* common.css 가 p·button·td 글자를 16px !important 로 강제 → 이 안에서는 더 구체적인 선택자로 */
    .hc p, .hc button, .hc label, .hc span, .hc input, .hc textarea { font-size: 13px !important; }

    .hc { margin-top: 2rem; text-align: left; }
    .hc-head { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
    .hc-head .hc-views { margin-right: -6px; }   /* 일정 추가 버튼과 붙여서 */
    .hc-nav { display: flex; align-items: center; gap: 4px; }
    .hc .hc-title { font-weight: 800; color: #222; margin: 0 0 10px; }
    .hc-month-wrap { position: relative; }
    .hc .hc-month { font-size: 17px !important; font-weight: 700; min-width: 108px; text-align: center; color: #222; border: none; background: none; border-radius: 6px; padding: 2px 8px; display: inline-flex; align-items: center; gap: 6px; }
    .hc .hc-month i { font-size: 10px; color: #999; transition: transform .15s; }
    .hc .hc-month:hover, .hc .hc-month.open { background: #F1F2F4; }
    .hc .hc-month.open i { transform: rotate(180deg); }
    .hc-picker-backdrop { position: fixed; inset: 0; z-index: 1040; }
    .hc-picker { position: absolute; top: calc(100% + 6px); left: 0; z-index: 1041; width: 264px; background: #fff; border-radius: 12px; box-shadow: 0 8px 28px rgba(0, 0, 0, .18); padding: 10px 12px 12px; }
    .hc-picker-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
    .hc .hc-picker-head b { font-size: 15px !important; color: #222; }
    .hc-picker-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; }
    .hc .hc-picker-month { height: 38px; border: 1px solid transparent; border-radius: 8px; background: #F7F8FA; color: #333; font-weight: 600; }
    .hc .hc-picker-month:hover { background: #FFF1DE; color: #E07F06; }
    .hc .hc-picker-month.now { border-color: #F6951C; color: #E07F06; }
    .hc .hc-picker-month.on { background: #F6951C; border-color: #F6951C; color: #fff; }
    .hc .hc-icon-btn { width: 28px; height: 28px; border: none; border-radius: 6px; background: #F1F2F4; color: #555; display: inline-flex; align-items: center; justify-content: center; padding: 0; }
    .hc .hc-icon-btn:hover { background: #FFEBD2; color: #f6951c; }
    .hc-views { display: inline-flex; border: 1px solid #dcdcdc; border-radius: 8px; overflow: hidden; }
    .hc .hc-view { border: none; background: #fff; color: #555; font-weight: 600; padding: 3px 14px; }
    .hc .hc-view + .hc-view { border-left: 1px solid #dcdcdc; }
    .hc .hc-view.on { background: #1FA971; color: #fff; }
    .hc .hc-view:not(.on):hover { background: #EAF7F0; color: #1FA971; }
    .hc-day-num span { cursor: pointer; }
    .hc-day-num span:hover { background: #F1F2F4; }

    /* 주·일 보기 */
    .hc-tg { border: 1px solid #e6e6e6; border-radius: 8px; background: #fff; overflow: hidden; }
    .hc-tg-row { display: flex; }
    .hc-tg-gutter { width: 64px; flex-shrink: 0; }
    .hc-tg-head { border-bottom: 1px solid #e6e6e6; background: #F7F8FA; }
    .hc-tg-col-head { flex: 1; min-width: 0; text-align: center; padding: 6px 0 4px; border-left: 1px solid #e6e6e6; }
    .hc .hc-tg-dow { display: block; font-size: 12px !important; color: #777; font-weight: 600; }
    .hc .hc-tg-date { display: inline-flex; width: 30px; height: 30px; align-items: center; justify-content: center; border-radius: 50%; font-size: 17px !important; font-weight: 700; color: #333; }
    .v-week .hc-tg-date { cursor: pointer; }
    .v-week .hc-tg-date:hover { background: #ececec; }
    .hc-tg-col-head.sun .hc-tg-dow, .hc-tg-col-head.sun .hc-tg-date { color: #E53935; }
    .hc-tg-col-head.sat .hc-tg-dow, .hc-tg-col-head.sat .hc-tg-date { color: #1E88E5; }
    .hc-tg-col-head.today .hc-tg-date { background: #f6951c; color: #fff; box-shadow: 0 0 0 4px rgba(246, 149, 28, .18); }
    .hc-tg-allday { border-bottom: 2px solid #e6e6e6; }
    .hc .hc-tg-allday-label { font-size: 11.5px !important; color: #888; text-align: right; padding: 6px 8px 0 0; }
    .hc-tg-allday-col { flex: 1; min-width: 0; border-left: 1px solid #e6e6e6; padding: 3px; min-height: 30px; display: flex; flex-direction: column; gap: 2px; cursor: pointer; }
    .hc-tg-body { height: 560px; overflow-y: auto; position: relative; }
    .hc-tg-hour-label { position: relative; }
    .hc .hc-tg-hour-label span { position: absolute; top: -8px; right: 8px; font-size: 11px !important; color: #999; white-space: nowrap; }
    .hc-tg-col { flex: 1; min-width: 0; position: relative; border-left: 1px solid #e6e6e6; cursor: pointer; }
    .hc-tg-col.today { background: #FFFAF3; }
    .hc-tg-col-head.today { background: transparent; }
    .hc-tg-allday-col.today { background: #FFFAF3; }
    .hc-tg-line { position: absolute; left: 0; right: 0; border-top: 1px solid #f0f0f0; pointer-events: none; }
    .hc-tg-now { position: absolute; left: 0; right: 0; border-top: 2px solid #E53935; z-index: 3; pointer-events: none; }
    .hc-tg-now::before { content: ''; position: absolute; left: -5px; top: -6px; width: 10px; height: 10px; border-radius: 50%; background: #E53935; }
    .hc .hc-tg-event { position: absolute; z-index: 2; border: none; border-radius: 5px; padding: 2px 6px; text-align: left; overflow: hidden;
        background: var(--c); color: #fff; display: flex; flex-direction: column; box-shadow: 0 0 0 1px #fff; }
    .hc .hc-tg-event:hover { filter: brightness(1.08); }
    .hc .hc-tg-event.done { opacity: .5; }
    .hc .hc-tg-event.done .hc-tg-event-title { text-decoration: line-through; }
    .hc .hc-tg-event span { color: #fff; }
    .hc .hc-tg-event-title { font-size: 12px !important; font-weight: 700; line-height: 15px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .hc .hc-tg-event-time { font-size: 11px !important; opacity: .9; line-height: 14px; }
    .hc .hc-tg-event.short { flex-direction: row; gap: 6px; align-items: center; }
    .v-day .hc-tg-event-title { white-space: normal; }

    .hc .hc-add-btn { padding: 4px 14px; font-weight: 700; background: #1FA971; border-color: #1FA971; color: #fff; }
    .hc .hc-add-btn:hover:not(:disabled), .hc .hc-add-btn:focus { background: #18935F; border-color: #18935F; color: #fff; }

    .hc-filters { display: flex; flex-direction: column; gap: 10px; margin: 12px 0 10px; }
    .hc-frow { display: flex; align-items: center; gap: 6px 10px; flex-wrap: wrap; }
    .hc-fchips { display: flex; flex-wrap: wrap; gap: 10px; flex: 1 1 auto; min-width: 0; }
    .hc .hc-fchip { display: inline-flex; align-items: center; gap: 5px; height: 28px; padding: 0 11px; border-radius: 14px; border: 1px solid #e2e2e2; background: #fff; color: #9a9a9a; font-size: 12px !important; font-weight: 600; cursor: pointer; white-space: nowrap; transition: background .12s, border-color .12s; }
    .hc .hc-fchip:hover { border-color: #cfcfcf; }
    .hc-fchip-dot { width: 8px; height: 8px; border-radius: 50%; background: #d4d4d4; flex: 0 0 auto; }
    .hc .hc-fchip.on { background: var(--bg); border-color: var(--bd); color: var(--ink); font-weight: 700; }
    .hc .hc-fchip.on .hc-fchip-dot { background: var(--c); }
    .hc .hc-fchip.on:hover { filter: brightness(.97); }
    .hc .hc-fchip.on.zero { font-weight: 600; }   /* 0건: 진하기는 그대로, 글자만 살짝 약하게 */
    .hc .hc-fchip-count { font-size: 11.5px !important; font-weight: 700; color: var(--ink); }
    .hc .hc-fchip:not(.on) .hc-fchip-count { color: #b0b0b0; }
    .hc-filter { display: inline-flex; align-items: center; gap: 6px; cursor: pointer; margin: 0; color: #444; font-weight: 600; user-select: none; }
    .hc-filter input { display: none; }
    .hc-check { width: 16px; height: 16px; border-radius: 4px; border: 2px solid var(--c); display: inline-flex; align-items: center; justify-content: center; color: #fff; background: #fff; }
    .hc-check i { font-size: 13px; line-height: 1; visibility: hidden; }
    .hc-filter input:checked + .hc-check { background: var(--c); }
    .hc-filter input:checked + .hc-check i { visibility: visible; }
    .hc .hc-filter-count { font-size: 11.5px !important; color: #9a9a9a; font-weight: 600; }
    .hc-filter-done { margin-left: auto; color: #777; }
    .hc .hc-loading { color: #a0a0a0; }

    .hc-grid { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); border-top: 1px solid #e6e6e6; border-left: 1px solid #e6e6e6; background: #fff; border-radius: 8px; overflow: hidden; }
    .hc-weekday { padding: 6px 0; text-align: center; font-size: 12px; font-weight: 700; color: #666; background: #F7F8FA; border-right: 1px solid #e6e6e6; border-bottom: 1px solid #e6e6e6; }
    .hc-weekday.sun { color: #E53935; }
    .hc-weekday.sat { color: #1E88E5; }
    .hc-day { min-height: 112px; border-right: 1px solid #e6e6e6; border-bottom: 1px solid #e6e6e6; padding: 4px 4px 6px; cursor: pointer; display: flex; flex-direction: column; min-width: 0; }
    .hc-day:hover { background: #FFFBF5; }
    .hc-day.other { background: #FAFAFA; }
    .hc-day.other .hc-day-num, .hc-day.other .hc-chip { opacity: .55; }
    .hc-day-num { text-align: center; margin-bottom: 3px; font-size: 12px; font-weight: 600; color: #333; }
    .hc-day-num.sun { color: #E53935; }
    .hc-day-num.sat { color: #1E88E5; }
    .hc-day-num span { display: inline-flex; width: 24px; height: 24px; align-items: center; justify-content: center; border-radius: 50%; }
    /* 오늘: 테두리 띠 대신 — 아주 연한 바탕 + 주황 날짜 동그라미(은은한 빛) + '오늘' 글자 */
    .hc-day.today .hc-day-num span { background: #f6951c; color: #fff; box-shadow: 0 0 0 4px rgba(246, 149, 28, .18); }
    .hc-day.today { background: #FFF9F1; }
    .hc-day.today:hover { background: #FFF3E3; }
    .hc-events { display: flex; flex-direction: column; gap: 2px; min-width: 0; }

    /* 종일·자동 항목 = 색 채운 막대, 시간 있는 일정 = 점 + 시간 (구글 캘린더처럼) */
    .hc .hc-chip { display: flex; align-items: center; gap: 4px; width: 100%; min-width: 0; border: none; border-radius: 4px; padding: 1px 6px; text-align: left; line-height: 18px;
        background: var(--bg); color: #222; font-size: 12px !important; font-weight: 600; box-shadow: inset 3px 0 0 var(--c); }
    .hc .hc-chip:hover { background: var(--bg2); }
    .hc .hc-chip.timed { background: transparent; color: #333; font-weight: 500; box-shadow: none; }
    .hc .hc-chip.timed:hover { background: #F1F2F4; }
    .hc .hc-chip.done .hc-chip-text { text-decoration: line-through; opacity: .55; }
    .hc .hc-chip span { font-size: 12px !important; }
    .hc-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--c); flex-shrink: 0; }
    .hc .hc-time { color: #777; flex-shrink: 0; font-size: 11.5px !important; }
    .hc-chip-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }
    .hc .hc-more { border: none; background: none; text-align: left; padding: 0 6px; color: #666; font-weight: 700; font-size: 11.5px !important; }
    .hc .hc-more:hover { color: #f6951c; }
    .hc .hc-note { color: #9a9a9a; margin: 8px 0 0 !important; font-size: 12px !important; }

    .hc-backdrop { position: fixed; inset: 0; z-index: 1040; }
    .hc-pop { position: fixed; z-index: 1041; background: #fff; border-radius: 10px; box-shadow: 0 8px 28px rgba(0, 0, 0, .2); padding: 10px 14px 12px; }
    .hc-pop-head { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; }
    .hc .hc-close { font-size: 10px !important; }
    .hc .hc-pop-type { font-size: 11.5px !important; font-weight: 700; color: var(--c); background: var(--bg); border-radius: 10px; padding: 1px 8px; }
    .hc .hc-pop-title { font-size: 16px !important; font-weight: 700; color: #222; margin: 2px 0 2px !important; word-break: keep-all; }
    .hc .hc-pop-title.done { text-decoration: line-through; color: #9a9a9a; }
    .hc .hc-pop-when { color: #666; margin: 0 0 8px !important; }
    .hc-pop-rows p { margin: 0 0 4px !important; color: #444; display: flex; gap: 6px; align-items: flex-start; }
    .hc-pop-rows i { color: #9a9a9a; }
    .hc .hc-pop-memo { white-space: pre-wrap; word-break: break-all; max-height: 120px; overflow-y: auto; }
    .hc-pop-actions { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
    .hc-done-toggle { display: inline-flex; align-items: center; gap: 6px; margin: 0; cursor: pointer; font-weight: 600; }
    .hc-done-toggle .form-check-input:checked { background-color: #39A966; border-color: #39A966; }
    .hc-pop-group { margin-top: 2px; }
    .hc .hc-pop-group-animal { color: #444; margin: 0 0 6px !important; display: flex; gap: 6px; }
    .hc-pop-group-animal i { color: #9a9a9a; }
    .hc-pop-req { display: flex; align-items: center; gap: 8px; padding: 4px 0; border-top: 1px dashed #eee; }
    .hc .hc-pop-req-name { flex: 1; min-width: 0; font-weight: 600; color: #333; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .hc .hc-pop-req-state { color: #888; font-size: 12px !important; }
    .hc .hc-pop-req-btn { padding: 0 8px; font-size: 12px !important; line-height: 22px; }
    .hc-pop-list { display: flex; flex-direction: column; gap: 3px; max-height: 300px; overflow-y: auto; }
    .hc .hc-pop-empty { color: #a0a0a0; margin: 4px 0 8px !important; }

    /* ── 모바일 (768px 이하) — PC 화면은 그대로 ── */
    @media (max-width: 768px) {
        .hc p, .hc button, .hc label, .hc span { font-size: 14px !important; }
        .hc-head { gap: 8px 10px; }
        /* 제목 아래 1줄: 이동, 2줄: 일/주/월 + 일정 추가 */
        .hc-nav { flex: 1 1 100%; }
        .hc .hc-month { font-size: 15px !important; min-width: 0; white-space: nowrap; }
        .hc .hc-icon-btn { width: 36px; height: 36px; }
        .hc-head .hc-views { margin: 0; margin-left: 0 !important; }
        .hc .hc-view { padding: 7px 16px; }
        .hc .hc-add-btn { margin-left: auto; padding: 7px 14px; }
        .hc-filters { gap: 10px; }
        .hc-filter { min-height: 28px; }
        /* 모바일: 줄마다 가로로 밀어서 (줄바꿈 X) */
        .hc-frow { flex-wrap: nowrap; }
        .hc-fchips { flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; -webkit-overflow-scrolling: touch; }
        .hc-fchips::-webkit-scrollbar { display: none; }
        .hc .hc-fchip { height: 31px; font-size: 13px !important; }
        .hc-filter-done { margin-left: 0; flex: 0 0 auto; }

        /* 월 보기: 칸이 좁아 글자 대신 색 막대 + 개수, 날짜를 누르면 그날 목록 */
        .hc-day { min-height: 64px; padding: 3px 2px 4px; }
        .hc-day-num { margin-bottom: 2px; }
        .hc .hc-day-num span { width: 24px; height: 24px; font-size: 13px !important; }
        .hc-events { gap: 2px; }
        .hc-day .hc-chip { height: 5px; padding: 0; border-radius: 3px; background: var(--c); box-shadow: none; pointer-events: none; }
        .hc-day .hc-chip.timed { background: var(--c); }
        .hc-day .hc-chip.done { opacity: .4; }
        .hc-day .hc-chip > * { display: none !important; }
        /* '+3개 더보기' → '+3' */
        .hc .hc-day .hc-more { pointer-events: none; padding: 0 1px; font-size: 0 !important; line-height: 13px; color: #888; }
        .hc .hc-day .hc-more::after { content: attr(data-more); font-size: 10.5px; }

        /* 주·일 보기: 시간 칸 좁게, 높이는 화면에 맞게 */
        .hc-tg-gutter { width: 40px; }
        .hc .hc-tg-hour-label span { right: 4px; font-size: 10.5px !important; }
        .hc .hc-tg-allday-label { font-size: 10.5px !important; padding-right: 4px; }
        .hc-tg-body { height: 60vh; }
        .hc .hc-tg-date { width: 28px; height: 28px; font-size: 15px !important; }
        .v-week .hc-tg-allday-col { padding: 2px 1px; }
        .v-week .hc-tg-allday-col .hc-chip { padding: 1px 2px; }
        .hc .v-week .hc-tg-allday-col .hc-chip span { font-size: 10.5px !important; }
        .v-week .hc-tg-event { padding: 1px 2px; }
        .hc .v-week .hc-tg-event-title { font-size: 10.5px !important; white-space: normal; word-break: break-all; }
        .hc .v-week .hc-tg-event-time { display: none; }

        /* 상세·하루 목록: 아래에서 올라오는 시트 */
        .hc-backdrop { background: rgba(0, 0, 0, .35); }
        .hc-pop { left: 0 !important; right: 0; top: auto !important; bottom: 0; width: 100% !important; border-radius: 16px 16px 0 0;
            max-height: 75vh; overflow-y: auto; padding: 14px 16px calc(16px + env(safe-area-inset-bottom)); }
        .hc .hc-close { font-size: 13px !important; padding: 10px; }
        .hc .hc-pop-title { font-size: 17px !important; }
        .hc-pop-list { max-height: none; gap: 6px; }
        .hc .hc-pop-list .hc-chip { padding: 8px 10px; line-height: 20px; }
        .hc .hc-pop-list .hc-chip span { font-size: 14px !important; }
        .hc .hc-pop-add { padding: 6px 12px; font-weight: 700; }
        .hc-pop-actions .btn, .hc .hc-pop-req-btn { min-height: 40px; padding: 6px 14px; }
        .hc-pop-req { padding: 8px 0; }
        .hc-done-toggle { min-height: 40px; }
    }

</style>
